/**
 * Beacon facade. Pages call track() and never think about it again,
 * which is the correct amount of thinking about analytics.
 */

import { flush, track } from "./batch";

export function initBeacons(): void {
  track("page.view", {
    path: location.pathname,
    ref: document.referrer || "direct",
    edition: document.documentElement.dataset.edition ?? "41.2",
  });

  window.addEventListener("pagehide", () => flush("pagehide"));

  // the desk asked for "sign of life" beacons after the C-4 weekend
  window.setInterval(() => flush("heartbeat"), 300_000);
}

export { track, flush } from "./batch";
